import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Postulante } from '../../interfaces/postulante';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-micuenta',
  templateUrl: './micuenta.component.html',
  styleUrls: ['./micuenta.component.css']
})
export class MicuentaComponent implements OnInit {

  public nombreMenuActivo: string = '';
  public postulante: Postulante;

  public menus: any[] = [
   { path: "/micuenta/dashboard", icon: "inicio.svg", nombre: "Inicio", active: false },
   { path: "/micuenta/postulaciones", icon: "postulaciones.svg", nombre: "Mis postulaciones", active: false },
   { path: "/micuenta/cursos", icon:"mis_cursos.svg", nombre: "Mis cursos", active: false},
   { path: "/micuenta/certificados", icon: "mis_certificados.svg", nombre: "Mis certificados", active: false },
   { path: "/micuenta/datos-personales", icon: "datos_personales.svg", nombre: "Datos personales", active: false },
   { path: "/", icon: "volver_al_sitio.svg", nombre: "Volver al sitio", active: false },
   { path: "/logout", icon: "cerrar_sesion.svg", nombre: "Cerrar sesión", active: false }
  
  ]

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) {
    router.events.subscribe((val) => {
        this.menus.forEach((menu, index) => {
          if(menu.path == router.url){
            this.menus[index].active = true;
            this.nombreMenuActivo = menu.nombre;
          }else{
            this.menus[index].active = false;
          }
        });
    });

    this.postulante = this.sessionService.getUser();
  }

  ngOnInit(): void {
  }




}
